var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrendFalling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #585858;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trend_copy",
    "data-name": "trend copy",
    transform: "translate(-1432 -856)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    className: "cls-1",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1432 856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_683",
    "data-name": "Shape 683",
    className: "cls-2",
    d: "M1439.292,864.707l1.414-1.414,12,12-1.414,1.414Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_684",
    "data-name": "Shape 684",
    className: "cls-2",
    width: 2,
    height: 8,
    transform: "translate(1451 869)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_684_copy",
    "data-name": "Shape 684 copy",
    className: "cls-2",
    width: 8,
    height: 2,
    transform: "translate(1445 875)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendFalling);
export default __webpack_public_path__ + "static/media/trend_falling.e5e12a4e24177a88da66cadccbcf76b4.svg";
export { ForwardRef as ReactComponent };